
export default {
  inject: ['downurl'],
  props: {
    icontype: {
      // wikifx_global--全球, apple-china--中国； android---安卓； goole---谷歌, android-mini---安卓mini
      type: String,
      default: ''
    },
    isShowIcon: {
      type: Boolean,
      default: true
    },
    propsWidth: {
      type: String,
      default: ''
    },
    propsHeight: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      urlData: this.downurl
    }
  },
  computed: {
    isTarget() {
      if (this.$store.state.isWiki == '3') {
        if (this.icontype == 'goole') {
          return '_blank'
        } else {
          return ''
        }
      } else {
        return '_blank'
      }
    },
    info() {
      const language = this.$store.state.LanguageCode
      let icon = ''
      let text = ''
      let url = ''
      let color = '#333'
      const linkAddress = {}
      this.urlData &&
        this.urlData.length > 0 &&
        this.urlData.forEach((el) => {
          if (el.Type == 1) {
            // 国内apk
            linkAddress.FXEYEapk = el.LinkAddress
          }
          if (el.Type == 2) {
            // 国外apk
            linkAddress.WikiFXapk = el.LinkAddress
          }
          if (el.Type == 3) {
            // ios国内
            // linkAddress.fxeyeIOS = el.LinkAddress
            linkAddress.fxeyeIOS = 'https://apps.apple.com/cn/app/wikifx-hk-fpa/id6464009659'
          }
          if (el.Type == 4) {
            // ios 国外
            linkAddress.wikifxIOS = el.LinkAddress
          }
          if (el.Type == 5) {
            // 谷歌
            linkAddress.playGoogle = el.LinkAddress
          }
          if (el.Type == 6) {
            // pc
            linkAddress.fxeyePC = el.LinkAddress
          }
          if (el.Type == 7) {
            // *国内ios全球
            linkAddress.FXeye_golbal_ios = el.LinkAddress
          }
        })
      if (this.icontype == 'apple_wikifx_global') {
        // *wikifx全球
        icon = 'icon-pingguo'

        if (language === 'zh-cn') {
          text = 'WikiFX（全球）'
        } else if (language === 'zh' || language === 'zh-hk' || language === 'zh-tw') {
          text = 'WikiFX（全球）'
        } else {
          text = 'WikiFX (Global)'
        }

        if (this.$store.state.isWiki == '2' || this.$store.state.isWiki == '4') {
          url = linkAddress.FXeye_golbal_ios
        } else {
          url = linkAddress.wikifxIOS
        }
      } else if (this.icontype == 'apple_china') {
        // *wikifx 中国
        icon = 'icon-pingguo'

        if (language === 'zh-cn') {
          text = 'WikiFX（中国）'
        } else if (language === 'zh' || language === 'zh-hk' || language === 'zh-tw') {
          text = 'WikiFX（中國）'
        } else {
          text = 'WikiFX (China)'
        }
        url = linkAddress.fxeyeIOS
      } else if (this.icontype == 'android') {
        icon = 'icon-anzhuo'
        text = 'WikiFX Pro（80M）'

        if (this.$store.state.isWiki == '1') {
          url = linkAddress.WikiFXapk
        } else if (this.$store.state.isWiki == '2' || this.$store.state.isWiki == '4') {
          url = linkAddress.FXEYEapk
        } else if (this.$store.state.isWiki == '3') {
          if (this.$store.state.myCountry.toLowerCase() == 'cn') {
            url = linkAddress.FXEYEapk
          } else {
            url = linkAddress.WikiFXapk
          }
        }
        color = '#36B374'
      } else if (this.icontype == 'goole') {
        icon = 'icon-google-play'

        if (language === 'zh-cn') {
          text = 'WikiFX Google Play'
        } else if (language === 'zh' || language === 'zh-hk' || language === 'zh-tw') {
          text = 'WikiFX Google Play'
        } else {
          text = 'WikiFX Google Play'
        }
        url = linkAddress.playGoogle
      } else if (this.icontype == 'android-mini') {
        text = 'WikiFX Mini（20M）'
        icon = 'icon-anzhuo'
        color = '#36B374'
        url = 'https://appdl.interface013.com/app/WikiFX-Mini.apk'
      }
      return {
        icon,
        text,
        url,
        color
      }
    }
  },
  methods: {
    icoType(v) {
      if (v === 'apple_china' || v === 'apple_wikifx_global') {
        return 'Download on the'
      } else if (v === 'android' || v === 'android-mini') {
        return 'Download Apk'
      } else {
        return 'GET IT ON'
      }
    }
  }
}
